"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var FilterSelector_1 = __importDefault(require("./FilterSelector"));
var useFilterSelector_1 = __importDefault(require("./useFilterSelector"));
var FilterSelectorContainer = function (props, ref) {
    var _a = useFilterSelector_1.default(props), state = _a.state, handleFilter = _a.handleFilter, handleResetSelect = _a.handleResetSelect, handleSelect = _a.handleSelect, handleToggleDisplaySelects = _a.handleToggleDisplaySelects;
    react_1.useImperativeHandle(ref, function () {
        return ({
            resetFilterSelector: handleResetSelect,
        });
    }, [handleResetSelect]);
    return (react_1.default.createElement(FilterSelector_1.default, __assign({}, state, props, { selectFn: handleSelect, filterFn: handleFilter, toggleDisplaySelectsFn: handleToggleDisplaySelects })));
};
exports.default = react_1.forwardRef(FilterSelectorContainer);
